import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import axios from "axios";
import { useForm, useWatch } from "react-hook-form";
import "../entries.css";

// Componente memoizado para tabla de empaques
const EmpaquesTable = React.memo(
  ({
    materialTypes,
    packagingTypes,
    formValues,
    handleCheckboxChange,
    handleInputChange,
  }) => (
    <table className="table table-striped mt-4" id="tabla-empaques">
      <thead className="text-center">
        <tr>
          <th style={{ backgroundColor: "#020C41", color: "white" }}></th>
          <th style={{ backgroundColor: "#020C41", color: "white" }}></th>
          <th style={{ backgroundColor: "#020C41", color: "white" }}>
            EMPAQUE
          </th>
          <th style={{ backgroundColor: "#020C41", color: "white" }}></th>
        </tr>
      </thead>
      <tbody className="text-center">
        <tr>
          <td></td>
          <td>SKID (tarima)</td>
          <td>GRANEL (BX)</td>
          <td>MENSAJERÍA</td>
        </tr>
        {materialTypes.map((mat, idx) => (
          <tr key={mat} data-id={mat}>
            <td>
              {
                ["Cartón", "Madera", "Plástico", "Metal", "Costal", "Bolsa"][
                  idx
                ]
              }
            </td>
            {packagingTypes.map((type) => (
              <td key={type}>
                <input
                  type="checkbox"
                  checked={!!formValues[`${mat}-${type}`]}
                  onChange={(e) =>
                    handleCheckboxChange(`${mat}-${type}`, e.target.checked)
                  }
                />
              </td>
            ))}
          </tr>
        ))}
        <tr data-id="other">
          <td>Otros</td>
          {packagingTypes.map((type) => (
            <td key={type}>
              <input
                type="text"
                className="form-control"
                value={formValues[`other-${type}`] || ""}
                onChange={(e) =>
                  handleInputChange(`other-${type}`, e.target.value)
                }
              />
            </td>
          ))}
        </tr>
        <tr data-id="can">
          <td>Bidones</td>
          <td>
            <input
              type="checkbox"
              checked={!!formValues["can-1"]}
              onChange={(e) => handleCheckboxChange("can-1", e.target.checked)}
            />
          </td>
          <td>
            <input
              type="checkbox"
              checked={!!formValues["can-2"]}
              onChange={(e) => handleCheckboxChange("can-2", e.target.checked)}
            />
          </td>
          <td className="d-flex">
            <div className="col-sm-4">
              <input
                type="checkbox"
                checked={!!formValues["can-31"]}
                onChange={(e) =>
                  handleCheckboxChange("can-31", e.target.checked)
                }
              />{" "}
              Cartón
            </div>
            <div className="col-sm-4">
              <input
                type="checkbox"
                checked={!!formValues["can-32"]}
                onChange={(e) =>
                  handleCheckboxChange("can-32", e.target.checked)
                }
              />{" "}
              Metal
            </div>
            <div className="col-sm-4">
              <input
                type="checkbox"
                checked={!!formValues["can-33"]}
                onChange={(e) =>
                  handleCheckboxChange("can-33", e.target.checked)
                }
              />{" "}
              Plástico
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  ),
);

// Componente memoizado para tabla de naturaleza y manejo
const NatureHandlingTable = React.memo(
  ({
    natureFields,
    handlingFields,
    formValues,
    handleCheckboxChange,
    handleInputChange,
    natureTotals,
    handlingTotals,
    activeTable,
  }) => (
    <div className={activeTable ? "" : "disabled-overlay"}>
      <table className="table table-striped mt-4">
        <colgroup>
          <col style={{ width: "10%" }} />
          <col style={{ width: "20%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "20%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
        </colgroup>
        <thead className="text-center">
          <tr>
            <th style={{ backgroundColor: "#020C41", color: "white" }}>
              NATURALEZA
            </th>
            <th style={{ backgroundColor: "#020C41", color: "white" }}></th>
            <th style={{ backgroundColor: "#020C41", color: "white" }}>
              Piezas
            </th>
            <th style={{ backgroundColor: "#020C41", color: "white" }}>Peso</th>
            <th style={{ backgroundColor: "#020C41", color: "white" }}>
              MANEJO
            </th>
            <th style={{ backgroundColor: "#020C41", color: "white" }}>
              MANEJO
            </th>
            <th style={{ backgroundColor: "#020C41", color: "white" }}>
              Piezas
            </th>
            <th style={{ backgroundColor: "#020C41", color: "white" }}>Peso</th>
          </tr>
        </thead>
        <tbody className="text-center">
          {natureFields.map((field, idx) => {
            const handlingField = handlingFields[idx];
            const natureChecked = !!formValues[`nature_${field.name}`];
            const handlingChecked = handlingField
              ? !!formValues[`handling_${handlingField.name}`]
              : false;

            return (
              <tr className="text-start" key={field.code}>
                <td className="text-end">{field.short}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={natureChecked}
                    onChange={(e) =>
                      handleCheckboxChange(
                        `nature_${field.name}`,
                        e.target.checked,
                      )
                    }
                  />{" "}
                  {field.label}
                </td>
                <td>
                  {natureChecked && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      step="0.001"
                      value={formValues[`nature_${field.name}_pieces`] || ""}
                      onChange={(e) =>
                        handleInputChange(
                          `nature_${field.name}_pieces`,
                          e.target.value,
                        )
                      }
                    />
                  )}
                </td>
                <td>
                  {natureChecked && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      step="0.001"
                      value={formValues[`nature_${field.name}_weight`] || ""}
                      onChange={(e) =>
                        handleInputChange(
                          `nature_${field.name}_weight`,
                          e.target.value,
                        )
                      }
                    />
                  )}
                </td>
                {handlingField ? (
                  <>
                    <td className="text-end">{handlingField.short}</td>
                    <td>
                      <input
                        type="checkbox"
                        checked={handlingChecked}
                        onChange={(e) =>
                          handleCheckboxChange(
                            `handling_${handlingField.name}`,
                            e.target.checked,
                          )
                        }
                      />{" "}
                      {handlingField.label}
                    </td>
                    <td>
                      {handlingChecked && (
                        <input
                          type="number"
                          className="form-control form-control-sm"
                          step="0.001"
                          value={
                            formValues[
                              `handling_${handlingField.name}_pieces`
                            ] || ""
                          }
                          onChange={(e) =>
                            handleInputChange(
                              `handling_${handlingField.name}_pieces`,
                              e.target.value,
                            )
                          }
                        />
                      )}
                    </td>
                    <td>
                      {handlingChecked && (
                        <input
                          type="number"
                          className="form-control form-control-sm"
                          step="0.001"
                          value={
                            formValues[
                              `handling_${handlingField.name}_weight`
                            ] || ""
                          }
                          onChange={(e) =>
                            handleInputChange(
                              `handling_${handlingField.name}_weight`,
                              e.target.value,
                            )
                          }
                        />
                      )}
                    </td>
                  </>
                ) : (
                  <td colSpan="4"></td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  ),
);

// Componente memoizado para secciones del formulario
const FormSections = React.memo(
  ({
    formValues,
    handleInputChange,
    temperatures,
    activeTable,
    hasTemperatureRequired, // Nueva prop
  }) => {
    // Memoizar temperatura seleccionada
    const selectedTemp = useMemo(() => {
      return temperatures.find(
        (temp) => temp.id.toString() === formValues.required_temp,
      );
    }, [temperatures, formValues.required_temp]);

    return (
      <div className={activeTable ? "row" : "disabled-overlay row"}>
        {/* Avería */}
        <div className="col-4">
          <p className="sub-title fw-bold mt-4" style={{ color: "#020C41" }}>
            Avería
          </p>
          <div className="row mb-1">
            <div className="col-6">
              <label>
                Sí{" "}
                <input
                  type="radio"
                  value="si"
                  checked={formValues.failure === "si"}
                  onChange={(e) => handleInputChange("failure", e.target.value)}
                />
              </label>
            </div>
            <div className="col-6">
              <label>
                No{" "}
                <input
                  type="radio"
                  value="no"
                  checked={formValues.failure === "no"}
                  onChange={(e) => handleInputChange("failure", e.target.value)}
                />
              </label>
            </div>
          </div>
          {formValues.failure === "si" && (
            <div className="fade-slide show">
              <div className="mt-3">
                <label className="fw-bold">Tipo:</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={formValues.type_failure || ""}
                  onChange={(e) =>
                    handleInputChange("type_failure", e.target.value)
                  }
                />
              </div>
              <div className="mt-3">
                <p
                  className="fw-bold mb-1"
                  style={{ fontSize: "0.9rem", marginTop: "1rem" }}
                >
                  ¿Es calificada como Carga de Alto Riesgo? (HRCM)
                </p>
                <div className="row mt-2">
                  <div className="col-6">
                    <label>
                      Sí{" "}
                      <input
                        type="radio"
                        value="si"
                        checked={formValues.hrcm === "si"}
                        onChange={(e) =>
                          handleInputChange("hrcm", e.target.value)
                        }
                      />
                    </label>
                  </div>
                  <div className="col-6">
                    <label>
                      No{" "}
                      <input
                        type="radio"
                        value="no"
                        checked={formValues.hrcm === "no"}
                        onChange={(e) =>
                          handleInputChange("hrcm", e.target.value)
                        }
                      />
                    </label>
                  </div>
                </div>
                <p style={{ fontSize: "0.75rem", marginTop: "1rem" }}>
                  En caso de ser positivo, notificar al inspector de seguridad.
                </p>
              </div>
            </div>
          )}
        </div>

        {/* INSPECCIÓN */}
        <div className="col-4">
          <p className="sub-title fw-bold mt-4" style={{ color: "#020C41" }}>
            INSPECCIÓN
          </p>
          <div className="row mt-2">
            <div className="col-4">
              <label>
                Rayos X{" "}
                <input
                  type="radio"
                  value="0"
                  checked={formValues.inspection === "0"}
                  onChange={(e) =>
                    handleInputChange("inspection", e.target.value)
                  }
                />
              </label>
            </div>
            <div className="col-4">
              <label>
                ETD{" "}
                <input
                  type="radio"
                  value="1"
                  checked={formValues.inspection === "1"}
                  onChange={(e) =>
                    handleInputChange("inspection", e.target.value)
                  }
                />
              </label>
            </div>
            <div className="col-4">
              <label>
                Ambos{" "}
                <input
                  type="radio"
                  value="2"
                  checked={formValues.inspection === "2"}
                  onChange={(e) =>
                    handleInputChange("inspection", e.target.value)
                  }
                />
              </label>
            </div>
          </div>
        </div>

        {/* TEMPERATURA */}
        <div className="col-4 ms-auto">
          <p className="sub-title fw-bold mt-4" style={{ color: "#020C41" }}>
            TEMPERATURA
          </p>
          <div className="d-flex align-items-center mb-2">
            <label className="fw-bold me-2 mb-0" style={{ width: "90px" }}>
              *Requerida
            </label>
            <select
              className="form-select"
              style={{ width: "50%" }}
              value={formValues.required_temp || ""}
              onChange={(e) =>
                handleInputChange("required_temp", e.target.value)
              }
              disabled={!hasTemperatureRequired}
            >
              {temperatures.map((temp) => (
                <option
                  key={temp.id}
                  value={temp.id}
                  disabled={hasTemperatureRequired && temp.name === "N/A"}
                >
                  {temp.name.replace("ºC", "°C")}
                </option>
              ))}
            </select>
          </div>
          <div className="d-flex align-items-center mb-2">
            <label className="fw-bold me-2 mb-0" style={{ width: "90px" }}>
              Camión
            </label>
            <input
              className="form-control"
              type="number"
              step="0.1"
              style={{ width: "50%" }}
              value={formValues.truck_temp || ""}
              onChange={(e) => handleInputChange("truck_temp", e.target.value)}
            />
          </div>
          <div className="d-flex align-items-center mb-2">
            <label className="fw-bold me-2 mb-0" style={{ width: "90px" }}>
              Anden
            </label>
            <input
              className="form-control"
              type="number"
              step="0.1"
              style={{ width: "50%" }}
              value={formValues.platform_temp || ""}
              onChange={(e) =>
                handleInputChange("platform_temp", e.target.value)
              }
            />
          </div>
          <div className="d-flex align-items-center">
            <label className="fw-bold me-2 mb-0" style={{ width: "90px" }}>
              Cooler
            </label>
            <input
              className="form-control"
              type="number"
              step="0.1"
              style={{ width: "50%" }}
              value={formValues.cooler_temp || ""}
              onChange={(e) => handleInputChange("cooler_temp", e.target.value)}
            />
          </div>
        </div>
      </div>
    );
  },
);

// Hook personalizado para manejar la lógica de temperatura
const useTemperatureControl = (formValues, temperatures, setValue) => {
  const hasTemperatureRequired = useMemo(() => {
    return formValues.handling_refri || formValues.handling_freezer;
  }, [formValues.handling_refri, formValues.handling_freezer]);

  useEffect(() => {
    if (hasTemperatureRequired) {
      // Si tiene REFRI o CONGELADOR, asegurar que no sea N/A
      const currentTemp = formValues.required_temp;
      if (!currentTemp || currentTemp === "") {
        // Buscar la primera opción que no sea N/A
        const nonNaOption = temperatures?.find((temp) => temp.name !== "N/A");
        if (nonNaOption) {
          setValue("required_temp", nonNaOption.id.toString(), {
            shouldDirty: true,
          });
        }
      }
    } else {
      // Si no tiene REFRI o CONGELADOR, forzar N/A
      const naOption = temperatures?.find((temp) => temp.name === "N/A");
      if (naOption && formValues.required_temp !== naOption.id.toString()) {
        setValue("required_temp", naOption.id.toString(), {
          shouldDirty: true,
        });
      }
    }
  }, [
    hasTemperatureRequired,
    temperatures,
    formValues.required_temp,
    setValue,
  ]);

  return { hasTemperatureRequired };
};

// Hook personalizado para manejar datos del formulario
const useFormData = (
  materialTypes,
  packagingTypes,
  natureFields,
  handlingFields,
  control,
) => {
  // Observar valores específicos
  const empaquesValues = useWatch({
    control,
    name: useMemo(
      () =>
        materialTypes
          .flatMap((mat) => packagingTypes.map((type) => `${mat}-${type}`))
          .concat([
            "other-1",
            "other-2",
            "other-3",
            "can-1",
            "can-2",
            "can-31",
            "can-32",
            "can-33",
          ]),
      [materialTypes, packagingTypes],
    ),
  });

  const natureValues = useWatch({
    control,
    name: useMemo(
      () =>
        natureFields.flatMap((f) => [
          `nature_${f.name}`,
          `nature_${f.name}_pieces`,
          `nature_${f.name}_weight`,
        ]),
      [natureFields],
    ),
  });

  const handlingValues = useWatch({
    control,
    name: useMemo(
      () =>
        handlingFields.flatMap((f) => [
          `handling_${f.name}`,
          `handling_${f.name}_pieces`,
          `handling_${f.name}_weight`,
        ]),
      [handlingFields],
    ),
  });

  const otherValues = useWatch({
    control,
    name: useMemo(
      () => [
        "failure",
        "hrcm",
        "inspection",
        "required_temp",
        "truck_temp",
        "platform_temp",
        "cooler_temp",
        "type_failure",
      ],
      [],
    ),
  });

  // Combinar todos los valores observados
  const formValues = useMemo(() => {
    const baseValues = {
      failure: "0",
      hrcm: "0",
      inspection: "",
      required_temp: "",
      truck_temp: "",
      platform_temp: "",
      cooler_temp: "",
      type_failure: "",
    };

    // Combinar arrays de valores
    const combineValues = (names, values) => {
      return names.reduce((acc, name, idx) => {
        acc[name] = values[idx];
        return acc;
      }, {});
    };

    const empaqueNames = materialTypes
      .flatMap((mat) => packagingTypes.map((type) => `${mat}-${type}`))
      .concat([
        "other-1",
        "other-2",
        "other-3",
        "can-1",
        "can-2",
        "can-31",
        "can-32",
        "can-33",
      ]);

    const natureNames = natureFields.flatMap((f) => [
      `nature_${f.name}`,
      `nature_${f.name}_pieces`,
      `nature_${f.name}_weight`,
    ]);

    const handlingNames = handlingFields.flatMap((f) => [
      `handling_${f.name}`,
      `handling_${f.name}_pieces`,
      `handling_${f.name}_weight`,
    ]);

    const otherNames = [
      "failure",
      "hrcm",
      "inspection",
      "required_temp",
      "truck_temp",
      "platform_temp",
      "cooler_temp",
      "type_failure",
    ];

    return {
      ...baseValues,
      ...combineValues(empaqueNames, empaquesValues),
      ...combineValues(natureNames, natureValues),
      ...combineValues(handlingNames, handlingValues),
      ...combineValues(otherNames, otherValues),
    };
  }, [
    empaquesValues,
    natureValues,
    handlingValues,
    otherValues,
    materialTypes,
    packagingTypes,
    natureFields,
    handlingFields,
  ]);

  return { formValues };
};

function LoadReviewForm({ master }) {
  const [activeTable, setActiveTable] = useState(false);
  const [reviewData, setReviewData] = useState(null);
  const [selectedHouse, setSelectedHouse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [temperatures, setTemperatures] = useState([]);
  const [masterInfo, setMasterInfo] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);

  // Referencia para mantener el foco
  const formContainerRef = useRef(null);

  // Configuraciones memoizadas
  const natureFields = useMemo(
    () => [
      {
        code: "1",
        name: "general",
        label: "GENERAL",
        field: "nat_cgo",
        short: "CGO",
      },
      {
        code: "2",
        name: "dangerous",
        label: "PELIGROSA",
        field: "nat_dgr",
        short: "DGR",
      },
      {
        code: "3",
        name: "perishable",
        label: "PERECEDERO",
        field: "nat_per",
        short: "PER",
      },
      {
        code: "4",
        name: "live_animal",
        label: "ANIMAL VIVO",
        field: "nat_avi",
        short: "AVI",
      },
      {
        code: "5",
        name: "high_value",
        label: "ALTO VALOR",
        field: "nat_val",
        short: "VAL",
      },
      {
        code: "6",
        name: "human_remains",
        label: "RESTOS HUMANOS",
        field: "nat_hum",
        short: "HUM",
      },
      {
        code: "7",
        name: "diplomatic_bag",
        label: "VALIJA DIPLOMATICA",
        field: "nat_dip",
        short: "DIP",
      },
      {
        code: "8",
        name: "press",
        label: "PRENSA",
        field: "nat_nwp",
        short: "NWP",
      },
      {
        code: "9",
        name: "mail",
        label: "MAIL",
        field: "nat_mal",
        short: "MAL",
      },
      {
        code: "10",
        name: "comat_am",
        label: "COMAT AM",
        field: "nat_com",
        short: "COM",
      },
      {
        code: "11",
        name: "declared_value",
        label: "VALOR DECLARADO",
        field: "nat_vic",
        short: "VIC",
      },
      {
        code: "12",
        name: "pharma",
        label: "PHARMA",
        field: "nat_pil",
        short: "PIL",
      },
    ],
    [],
  );

  const handlingFields = useMemo(
    () => [
      {
        code: "1",
        name: "ice",
        label: "HIELO-SECO",
        field: "han_ice",
        short: "ICE",
      },
      {
        code: "2",
        name: "wet",
        label: "HÚMEDA",
        field: "han_wet",
        short: "WET",
      },
      {
        code: "3",
        name: "big",
        label: "GRANDE",
        field: "han_big",
        short: "BIG",
      },
      {
        code: "4",
        name: "heavy",
        label: "HEAVY",
        field: "han_hea",
        short: "HEA",
      },
      {
        code: "5",
        name: "fragile",
        label: "FRAGIL",
        field: "han_hwc",
        short: "HWC",
      },
      {
        code: "6",
        name: "refri",
        label: "REFRI",
        field: "han_col",
        short: "COL",
      },
      {
        code: "7",
        name: "freezer",
        label: "CONGELADOR",
        field: "han_fro",
        short: "FRO",
      },
      {
        code: "8",
        name: "na",
        label: "NO APLICA",
        field: "han_na",
        short: "N/A",
      },
    ],
    [],
  );

  const materialTypes = useMemo(
    () => ["cardboard", "wood", "plastic", "metal", "sack", "bag"],
    [],
  );
  const packagingTypes = useMemo(() => ["1", "2", "3"], []);

  const { control, setValue, reset } = useForm({
    defaultValues: {
      failure: "0",
      hrcm: "0",
      inspection: "",
      required_temp: "",
      truck_temp: "",
      platform_temp: "",
      cooler_temp: "",
    },
    mode: "onChange",
  });

  // Usar hook personalizado para datos del formulario
  const { formValues } = useFormData(
    materialTypes,
    packagingTypes,
    natureFields,
    handlingFields,
    control,
  );

  // Hook para control de temperatura
  const { hasTemperatureRequired } = useTemperatureControl(
    formValues,
    temperatures,
    setValue,
  );

  // Calcular totales - memoizado
  const { natureTotals, handlingTotals } = useMemo(() => {
    const calculateTotals = (fields, prefix) => {
      let totalPieces = 0;
      let totalWeight = 0;

      fields.forEach((field) => {
        const pieces =
          parseFloat(formValues[`${prefix}_${field.name}_pieces`]) || 0;
        const weight =
          parseFloat(formValues[`${prefix}_${field.name}_weight`]) || 0;
        totalPieces += pieces;
        totalWeight += weight;
      });

      return { totalPieces, totalWeight };
    };

    return {
      natureTotals: calculateTotals(natureFields, "nature"),
      handlingTotals: calculateTotals(handlingFields, "handling"),
    };
  }, [formValues, natureFields, handlingFields]);

  // Función para valores seguros
  const safeValue = useCallback(
    (v, d = "N/A") => (v !== null && v !== undefined ? v : d),
    [],
  );

  // Cargar datos de revisión - memoizado
  const loadReviewData = useCallback(
    async (houseId = null) => {
      setLoading(true);
      try {
        const API_URL = `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/location/${houseId ? "arriveReviewHouse" : "arriveReview"}`;
        const payload = houseId
          ? { awb: master.resp?.awb, house_id: houseId }
          : { awb: master.resp?.awb, house_id: "" };

        const { data: res } = await axios.post(API_URL, payload, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
          },
        });

        if (res.code === 0 || res.code === 1) {
          setReviewData(res.data);
          setTemperatures(res.data.temperatures || []);

          if (res.data.resp) {
            setMasterInfo({
              awb: res.data.resp.awb,
              origin: res.data.resp.orig || res.data.resp.master_orig,
              destination: res.data.resp.dest || res.data.resp.master_dest,
              pieces: res.data.resp.pieces || res.data.resp.master_pieces,
              weight: res.data.resp.weight || res.data.resp.master_weight,
              volume: res.data.resp.volume || res.data.resp.master_volume,
              merchandise: res.data.resp.merch || res.data.resp.master_merch,
              chargeable_weight:
                res.data.resp.chargeable_weight ||
                res.data.resp.master_chargeable_weight,
            });
          }

          reset({
            failure: "0",
            hrcm: "0",
            inspection: "",
            required_temp: "",
            truck_temp: "",
            platform_temp: "",
            cooler_temp: "",
          });

          if (res.data.preve_save) {
            loadSavedData(res.data);
          } else if (res.data.reception) {
            loadReceptionData(res.data.reception);
          }

          if (houseId) {
            setSelectedHouse(houseId);
          }
        }
      } catch (error) {
        console.error("Error loading review data:", error);
      } finally {
        setLoading(false);
      }
    },
    [master, reset],
  );

  // Cargar datos de recepción - memoizado
  const loadReceptionData = useCallback(
    (receptionData) => {
      if (!receptionData) return;

      natureFields.forEach((field) => {
        if (receptionData[field.field]) {
          setValue(`nature_${field.name}`, true, { shouldDirty: false });
          setValue(
            `nature_${field.name}_pieces`,
            receptionData[`${field.field}_pieces`] || "",
            { shouldDirty: false },
          );
          setValue(
            `nature_${field.name}_weight`,
            receptionData[`${field.field}_weight`] || "",
            { shouldDirty: false },
          );
        }
      });

      handlingFields.forEach((field) => {
        if (receptionData[field.field]) {
          setValue(`handling_${field.name}`, true, { shouldDirty: false });
          setValue(
            `handling_${field.name}_pieces`,
            receptionData[`${field.field}_pieces`] || "",
            { shouldDirty: false },
          );
          setValue(
            `handling_${field.name}_weight`,
            receptionData[`${field.field}_weight`] || "",
            { shouldDirty: false },
          );
        }
      });
    },
    [natureFields, handlingFields, setValue],
  );

  // Cargar datos guardados - memoizado
  const loadSavedData = useCallback(
    (data) => {
      if (!data.preve_save) return;

      const materials = data.materials || {};
      materialTypes.forEach((mat) => {
        materials[mat]?.forEach((val) => {
          if (val) setValue(`${mat}-${val}`, true, { shouldDirty: false });
        });
      });

      if (data.other) {
        data.other.forEach((val, idx) => {
          if (val && val.trim() !== "")
            setValue(`other-${idx + 1}`, val, { shouldDirty: false });
        });
      }

      data.can?.forEach((val) => {
        if (val === "1" || val === "2") {
          setValue(`can-${val}`, true, { shouldDirty: false });
        }
      });

      if (data.preve_save.can) {
        const canValues = data.preve_save.can.split(",");
        canValues.forEach((val) => {
          if (val === "3") setValue(`can-31`, true, { shouldDirty: false });
          if (val === "4") setValue(`can-32`, true, { shouldDirty: false });
          if (val === "5") setValue(`can-33`, true, { shouldDirty: false });
        });
      }

      if (data.nature && data.pieces_nature && data.weight_nature) {
        data.nature.forEach((nat, idx) => {
          const field = natureFields.find((f) => f.code === nat);
          if (field && data.pieces_nature[idx] && data.weight_nature[idx]) {
            setValue(`nature_${field.name}`, true, { shouldDirty: false });
            setValue(`nature_${field.name}_pieces`, data.pieces_nature[idx], {
              shouldDirty: false,
            });
            setValue(`nature_${field.name}_weight`, data.weight_nature[idx], {
              shouldDirty: false,
            });
          }
        });
      }

      if (data.handling && data.pieces_handling && data.weight_handling) {
        data.handling.forEach((han, idx) => {
          const field = handlingFields.find((f) => f.code === han);
          if (field && data.pieces_handling[idx] && data.weight_handling[idx]) {
            setValue(`handling_${field.name}`, true, { shouldDirty: false });
            setValue(
              `handling_${field.name}_pieces`,
              data.pieces_handling[idx],
              { shouldDirty: false },
            );
            setValue(
              `handling_${field.name}_weight`,
              data.weight_handling[idx],
              { shouldDirty: false },
            );
          }
        });
      }

      const prev = data.preve_save;
      setValue(
        "failure",
        prev.failure === "1" || prev.failure === 1 ? "si" : "no",
        { shouldDirty: false },
      );
      setValue("type_failure", prev.type_failure || "", { shouldDirty: false });
      setValue("hrcm", prev.hrcm === "1" || prev.hrcm === 1 ? "si" : "no", {
        shouldDirty: false,
      });
      setValue("inspection", prev.inspection?.toString() || "", {
        shouldDirty: false,
      });
      setValue("required_temp", prev.required_temp || "", {
        shouldDirty: false,
      });
      setValue("truck_temp", prev.truck_temp || "", { shouldDirty: false });
      setValue("platform_temp", prev.platform_temp || "", {
        shouldDirty: false,
      });
      setValue("cooler_temp", prev.cooler_temp || "", { shouldDirty: false });
    },
    [materialTypes, natureFields, handlingFields, setValue],
  );

  const handleHouseSelect = useCallback(
    (house) => {
      loadReviewData(house.id);
    },
    [loadReviewData],
  );

  // Función para manejar submit - memoizada
  const onSubmit = useCallback(
    async (event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      setSubmitLoading(true);

      try {
        const materialArrays = {};
        materialTypes.forEach((mat) => {
          materialArrays[mat] = packagingTypes.filter(
            (type) => formValues[`${mat}-${type}`],
          );
        });

        const canArray = [];
        if (formValues["can-1"]) canArray.push("1");
        if (formValues["can-2"]) canArray.push("2");
        if (formValues["can-31"]) canArray.push("3");
        if (formValues["can-32"]) canArray.push("4");
        if (formValues["can-33"]) canArray.push("5");

        const natureArray = [];
        const pNatureArray = [];
        const wNatureArray = [];

        natureFields.forEach((field) => {
          if (formValues[`nature_${field.name}`]) {
            natureArray.push(field.code);
            pNatureArray.push(formValues[`nature_${field.name}_pieces`] || "0");
            wNatureArray.push(formValues[`nature_${field.name}_weight`] || "0");
          }
        });

        const handlingArray = [];
        const pHandleArray = [];
        const wHandleArray = [];

        handlingFields.forEach((field) => {
          if (formValues[`handling_${field.name}`]) {
            handlingArray.push(field.code);
            pHandleArray.push(
              formValues[`handling_${field.name}_pieces`] || "0",
            );
            wHandleArray.push(
              formValues[`handling_${field.name}_weight`] || "0",
            );
          }
        });

        const userId = sessionStorage.getItem("userId") || "1";

        const payload = {
          master_id: reviewData?.resp?.id || master.resp?.id,
          id_house: selectedHouse || null,
          cardboard: materialArrays.cardboard,
          wood: materialArrays.wood,
          plastic: materialArrays.plastic,
          metal: materialArrays.metal,
          sack: materialArrays.sack,
          bag: materialArrays.bag,
          other: [
            formValues["other-1"] || "",
            formValues["other-2"] || "",
            formValues["other-3"] || "",
          ],
          can: canArray.length > 0 ? canArray : null,
          nature: natureArray,
          p_nature: pNatureArray,
          w_nature: wNatureArray,
          handling: handlingArray,
          p_handle: pHandleArray,
          w_handle: wHandleArray,
          failure: formValues.failure === "si" ? 1 : 0,
          type_failure: formValues.type_failure || null,
          hrcm: formValues.hrcm === "si" ? 1 : 0,
          inspection: formValues.inspection || "0",
          required_temp: formValues.required_temp || "",
          truck_temp: formValues.truck_temp || null,
          platform_temp: formValues.platform_temp || null,
          cooler_temp: formValues.cooler_temp || null,
          user_id: parseInt(userId),
        };

        const API_URL = `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/location/entriesReviewSave`;
        const { data: res } = await axios.post(API_URL, payload, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
          },
        });

        if (res.code === 0) {
          alert("Datos guardados exitosamente");
          loadReviewData(selectedHouse);
        } else {
          alert(res.message || "Error al guardar los datos");
        }
      } catch (error) {
        console.error("Error saving data:", error);
        alert(
          "Error al guardar los datos: " +
            (error.response?.data?.message || error.message),
        );
      } finally {
        setSubmitLoading(false);
      }
    },
    [
      reviewData,
      master,
      selectedHouse,
      natureFields,
      handlingFields,
      materialTypes,
      packagingTypes,
      formValues,
      loadReviewData,
    ],
  );

  // Efecto para cargar datos iniciales
  useEffect(() => {
    if (master?.data?.length > 0) {
      return;
    }
    loadReviewData();
  }, [master, loadReviewData]);

  // Efecto para controlar tabla activa
  useEffect(() => {
    const hasEmpaqueChecked =
      materialTypes.some((mat) =>
        packagingTypes.some((type) => formValues[`${mat}-${type}`]),
      ) ||
      ["1", "2", "31", "32", "33"].some((type) => formValues[`can-${type}`]);

    setActiveTable(hasEmpaqueChecked);
  }, [formValues, materialTypes, packagingTypes]);

  // Funciones para manejar cambios - memoizadas
  const handleCheckboxChange = useCallback(
    (name, checked) => {
      setValue(name, checked, { shouldDirty: true });
    },
    [setValue],
  );

  const handleInputChange = useCallback(
    (name, value) => {
      setValue(name, value, { shouldDirty: true });
    },
    [setValue],
  );

  // Bloquear submit por Enter
  const blockEnterSubmit = useCallback((e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  }, []);

  // Evitar scroll si React re-renderiza
  useEffect(() => {
    formContainerRef.current?.scrollIntoView({
      block: "nearest",
      behavior: "auto",
    });
  }, []);

  // Renderizar tabla de subproductos
  if (master?.data?.length > 0 && !selectedHouse) {
    return (
      <div className="mt-5">
        <table className="table" style={{ width: "70%", margin: "0 auto" }}>
          <thead className="text-center">
            <tr>
              <th style={{ backgroundColor: "#020C41", color: "white" }}>
                HBS
              </th>
              <th style={{ backgroundColor: "#020C41", color: "white" }}>
                Fecha
              </th>
              <th style={{ backgroundColor: "#020C41", color: "white" }}>
                Piezas
              </th>
              <th style={{ backgroundColor: "#020C41", color: "white" }}>
                Peso
              </th>
              <th style={{ backgroundColor: "#020C41", color: "white" }}>
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="text-center">
            {master.data.map((sub, index) => (
              <tr key={index}>
                <td>{safeValue(sub.hbs)}</td>
                <td>{safeValue(new Date(sub.date).toLocaleDateString())}</td>
                <td>{safeValue(sub.pieces)}</td>
                <td>{safeValue(sub.weight)}</td>
                <td>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => handleHouseSelect(sub)}
                  >
                    ➜
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  if (loading) return <div className="text-center mt-5">Cargando...</div>;

  const displayInfo = masterInfo || {
    awb: master.resp?.awb,
    origin: master.resp?.master_orig,
    destination: master.resp?.master_dest,
    pieces: master.resp?.master_pieces,
    weight: master.resp?.master_weight,
    volume: master.resp?.master_volume,
    merchandise: master.resp?.master_merch,
  };

  // Función para manejar el submit del formulario
  const handleFormSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onSubmit(event);
  };

  return (
    <div className="container-fluid" ref={formContainerRef}>
      {/* Información del master */}
      <div className="row">
        {selectedHouse && reviewData?.house ? (
          <>
            <div className="col-md-3 mb-2">
              <span className="">
                <label className="fw-bold">Master:</label> {displayInfo.awb}
              </span>
            </div>
            <div className="col-md-3 mb-2">
              <span className="">
                <label className="fw-bold">Origen:</label> {displayInfo.origin}
              </span>
            </div>
            <div className="col-md-3 mb-2">
              <span className="">
                <label className="fw-bold">Destino:</label>{" "}
                {displayInfo.destination}
              </span>
            </div>
            <div className="col-md-3 mb-2">
              <span className="">
                <label className="fw-bold">House:</label>{" "}
                <span className="add-commas">{reviewData.house.hbs}</span>
              </span>
            </div>
            <div className="col-md-3 mb-2">
              <span className="">
                <label className="fw-bold">Piezas House:</label>{" "}
                <span className="add-commas">{reviewData.house.pieces}</span>
              </span>
            </div>
            <div className="col-md-3 mb-2">
              <span className="">
                <label className="fw-bold">Peso House:</label>{" "}
                <span className="add-commas">
                  {parseFloat(reviewData.house.gross_weight).toFixed(6)}
                </span>
              </span>
            </div>
            <div className="col-md-3 mb-2">
              <span className="">
                <label className="fw-bold">Volúmen House:</label>{" "}
                <span className="add-commas">
                  {parseFloat(reviewData.house.volume).toFixed(6)}
                </span>
              </span>
            </div>
          </>
        ) : (
          <>
            <div className="col-md-3 mb-2">
              <span className="">
                <label className="fw-bold">Master:</label> {displayInfo.awb}
              </span>
            </div>
            <div className="col-md-3 mb-2">
              <span className="">
                <label className="fw-bold">Origen:</label> {displayInfo.origin}
              </span>
            </div>
            <div className="col-md-3 mb-2">
              <span className="">
                <label className="fw-bold">Destino:</label>{" "}
                {displayInfo.destination}
              </span>
            </div>
            <div className="col-md-3 mb-2">
              <span className="">
                <label className="fw-bold">Piezas Master:</label>{" "}
                <span className="add-commas">{displayInfo.pieces}</span>
              </span>
            </div>
            <div className="col-md-3 mb-2">
              <span className="">
                <label className="fw-bold">Peso Master:</label>{" "}
                <span className="add-commas">{displayInfo.weight}</span>
              </span>
            </div>
            <div className="col-md-3 mb-2">
              <span className="">
                <label className="fw-bold">Volúmen Master:</label>{" "}
                <span className="add-commas">{displayInfo.volume}</span>
              </span>
            </div>
          </>
        )}
        <div className="col-md-3 mb-2">
          <span className="">
            <label className="fw-bold">Tipo de mercancía:</label>{" "}
            {displayInfo.merchandise}
          </span>
        </div>
      </div>

      {/* Sección de recepción */}
      <p className="sub-title fw-bold mt-4" style={{ color: "#020C41" }}>
        Sección Recepción de Carga
      </p>

      {/* Formulario con submit manual */}
      <form onSubmit={handleFormSubmit} onKeyDown={blockEnterSubmit} noValidate>
        <EmpaquesTable
          materialTypes={materialTypes}
          packagingTypes={packagingTypes}
          formValues={formValues}
          handleCheckboxChange={handleCheckboxChange}
          handleInputChange={handleInputChange}
        />

        <NatureHandlingTable
          natureFields={natureFields}
          handlingFields={handlingFields}
          formValues={formValues}
          handleCheckboxChange={handleCheckboxChange}
          handleInputChange={handleInputChange}
          natureTotals={natureTotals}
          handlingTotals={handlingTotals}
          activeTable={activeTable}
        />

        <FormSections
          formValues={formValues}
          handleInputChange={handleInputChange}
          temperatures={temperatures}
          activeTable={activeTable}
          hasTemperatureRequired={hasTemperatureRequired}
        />

        <div className="row">
          <div className="col mt-4 d-flex justify-content-end">
            <button
              type="button"
              onClick={handleFormSubmit}
              className="btnn"
              disabled={
                !activeTable ||
                (!formValues.inspection && formValues.inspection !== "0") ||
                submitLoading
              }
            >
              {submitLoading ? "Guardando..." : "Guardar"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default LoadReviewForm;
